/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiCitiesAndNeighborhoodsListParams } from './model/apiCitiesAndNeighborhoodsListParams';
import type { PaginatedBrandLocalityServiceCitiesItemList } from './model/paginatedBrandLocalityServiceCitiesItemList';

/**
 * Returns the top SEO location pages for the given country and service type.
 */
export const apiCitiesAndNeighborhoodsList = (
  params?: ApiCitiesAndNeighborhoodsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedBrandLocalityServiceCitiesItemList>({
    url: `/api/v7/cities-and-neighborhoods/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiCitiesAndNeighborhoodsListQueryKey = (
  params?: ApiCitiesAndNeighborhoodsListParams
) => {
  return [`/api/v7/cities-and-neighborhoods/`, ...(params ? [params] : [])] as const;
};

export const getApiCitiesAndNeighborhoodsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCitiesAndNeighborhoodsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCitiesAndNeighborhoodsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>> = ({
    signal,
  }) => apiCitiesAndNeighborhoodsList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiCitiesAndNeighborhoodsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>
>;
export type ApiCitiesAndNeighborhoodsListQueryError = ErrorType<unknown>;

export function useApiCitiesAndNeighborhoodsList<
  TData = Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCitiesAndNeighborhoodsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiCitiesAndNeighborhoodsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
